<script setup>
import SurveyCard from '@/components/calendar/drawer/pages/cards/SurveyCard.vue';
import { addContentLogAPI } from '@/api/logServiceApi';

const emit = defineEmits(['goToOverView', 'postRate']);
const props = defineProps({
  ratingResult: Number,
  ratingStatus: Boolean,
});

const goToOverView = () => {
  addContentLogAPI('ap_personality_btn_restart');
  emit('goToOverView');
};

const postRate = (score) => {
  emit('postRate', score);
};
</script>

<template>
  <VCard class="personality-card full-height">
    <div class="personality-wrapper outro">
      <div class="rating-personality">
        <SurveyCard
          style="width: 100%"
          :ratingResult="ratingResult"
          :ratingStatus="ratingStatus"
          @postRate="postRate"
        />
        <div class="personality-replay">
          <button class="replay-btn content_review_button_restart" @click="goToOverView()">
            <i class="return-icon"></i>
            다시보기
          </button>
        </div>
      </div>
    </div>
  </VCard>
</template>

<style scoped>
/* 필요한 스타일이 있다면 여기에 추가 */
</style>
